import { QueryFunction, useQuery } from '@tanstack/react-query';

import { InvoiceListParams, InvoiceResponse } from '@/api/invoices';
import { axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';
import { pickDefined } from '@/utils';

export const getInvoicesList: QueryFunction<InvoiceResponse> = async ({
    queryKey,
    signal,
}): Promise<InvoiceResponse> => {
    const { limit, status, startingAfter, endingBefore } = queryKey[1] as InvoiceListParams;
    const params = pickDefined({ limit, status, startingAfter, endingBefore });
    return axios.get<InvoiceResponse, InvoiceResponse>('/api/v2/invoices', {
        params,
        signal,
    });
};

type QueryFnType = typeof getInvoicesList;

type UseSubsciptionsInfoOptions = {
    config?: QueryConfig<QueryFnType>;
} & InvoiceListParams;

export const useInvoicesList = ({
    config,
    limit,
    status,
    startingAfter,
    endingBefore,
}: UseSubsciptionsInfoOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['stripe-invoices-list', { limit, status, startingAfter, endingBefore }],
        queryFn: getInvoicesList,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
